// `ApprovalGate` — wraps the operational route subtree.
//
// Gating policy:
//   loading            → centered LoadingState (no operational chrome leaks)
//   error              → redirect to /approvazione (page renders the error
//                        UI once; we don't show two competing error states)
//   ACTIVE             → render <Outlet /> (operational area)
//   PENDING_APPROVAL   → redirect to /approvazione
//   REJECTED           → redirect to /approvazione
//   NO_MEMBERSHIP      → redirect to /approvazione
//
// Loop avoidance:
//   /approvazione is mounted OUTSIDE this gate (top-level Route in
//   routes.tsx), so a redirect TO /approvazione never re-enters the gate.
//   ApprovalPage handles the inverse: an ACTIVE response there triggers
//   <Navigate to="/" />, which DOES re-enter this gate, but with cache
//   already warm + canOperate=true → Outlet renders, no loop.

import { Navigate, Outlet } from 'react-router-dom';
import { LoadingState } from '@/components/shared/LoadingState';
import { useApprovalState } from '../hooks/useApprovalState';
import { canAccessOperationalArea } from '../lib/approval-routing';

export function ApprovalGate(): JSX.Element {
  const query = useApprovalState();

  if (query.isLoading || query.isPending) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <LoadingState message="Verifica accesso…" />
      </div>
    );
  }

  if (query.isError || !canAccessOperationalArea(query.data)) {
    return <Navigate to="/approvazione" replace />;
  }

  return <Outlet />;
}
